<script setup>
import { computed, ref } from 'vue'
import ActionModal from '@/components/modals/ActionModal.vue'
import DropDownMenu from '@/components/Atoms/DropDownMenu.vue'
import DropDownMenuItem from '@/components/Atoms/DropDownMenuItem.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconChevronDown from '@/components/icon/IconChevronDown.vue'

const props = defineProps({
	groups: {
		type: Array,
		default: () => [],
	},
})

const isVisible = defineModel('isVisible', { type: Boolean, default: false })
const targetGroupName = defineModel('targetGroupName', { type: String, default: '' })

const emit = defineEmits(['confirm'])
const groupDropdown = ref(null)

function displayName(name) {
	return name.length > 40 ? name.slice(0, 40) + '...' : name
}

const selectedLabel = computed(() => {
	if (!targetGroupName.value) return 'Select a group'
	return displayName(targetGroupName.value)
})

function selectGroup(name) {
	targetGroupName.value = name
	groupDropdown.value?.hideDropDownMenu?.()
}

function itemClasses(name) {
	const base = 'h-9 !px-3 flex items-center w-full text-tiny leading-none truncate transition-colors hover:bg-surface-3 hover:text-white'
	const state = name === targetGroupName.value ? 'bg-surface-3 text-white' : 'text-surface-text-1'
	return `${base} ${state}`
}
</script>

<template>
	<ActionModal
		v-model:isVisible="isVisible"
		title="Move to Group"
		confirm-text="Move"
		cancel-text="Cancel"
		:scroll-body="false"
		:on-submit="() => emit('confirm')"
	>
		<DropDownMenu
			ref="groupDropdown"
			type="flat"
			size="md"
			full-width
			class="w-full"
			list-width="w-full"
			list-classes="!border !border-surface-4 !rounded-md !p-1"
			wrapper-class="mt-0.5 w-full"
		>
			<template #toggle-button>
				<span class="truncate" :class="targetGroupName ? 'text-surface-text-1' : 'text-surface-7'">
					{{ selectedLabel }}
				</span>
				<IconBase class="ml-auto shrink-0">
					<IconChevronDown />
				</IconBase>
			</template>
			<template #menu-items>
				<DropDownMenuItem
					v-for="group in groups"
					:key="group.name"
					:custom-classes="itemClasses(group.name)"
					@click="selectGroup(group.name)"
				>
					{{ displayName(group.name) }}
				</DropDownMenuItem>
			</template>
		</DropDownMenu>
	</ActionModal>
</template>
